// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2zjlD","notes":"Notes_notes__1HbRS"};